import axios, { postJson } from '@dap/shared-utils/http.js';

export default {
    getTableList (params = {}) {
        return axios.get('/dapper/api/acc/accounts', { params });
    },

    editComment (params = {}) {
        return axios.put('/dapper/api/acc/accounts', params);
    },

    editGame (params = {}) {
        return axios.put('/dapper/api/acc/account_game', params);
    },

    PostForm (params = {}) {
        return axios.put('/dapper/api/acc/account_game', params);
    },

    getGdtFilter (params = {}) {
        return axios.get('/dapper/api/acc/gdt_filter', params);
    },

    getGdtAuthCode (params) {
        return axios.post('/dapper/api/acc/auth/oauth', params);
    },

    updateUseStatus (params = {}) {
        return axios.put('/dapper/api/acc/accounts/use_status', params);
    },

    getAgentDefaultAccount (params = {}) {
        return axios.get('/dapper/api/acc/agent/default_account', { params });
    },

    editAccount: (params) => axios.post('/dapper/api/acc/accounts', params),
    getMasterList: (params) => axios.get('/dapper/api/acc/master', { params }),

    // 快手开放平台账号列表
    getKsUserList: params => axios.get('/dapper/api/acc/ks_user_platform/list', { params }),
    // 新增快手平台账号
    addKsUser: params => postJson('/dapper/api/acc/ks_user_platform/create', params),
    // 获取快手平台授权url
    getKsAuthLink: params => axios.get('/dapper/api/acc/ks_user_platform/oauth2_url', { params }),
    // 快手平台授权回调
    revokeKsToken: params => postJson('/dapper/api/acc/ks_user_platform/oauth2', params),
    // 新增海外-非深度渠道账户
    createAccount (params = {}) {
        return axios.post('/dapper/api/acc/v2/accounts', params, {
            headers: { 'Content-Type': 'application/json' }
        });
    },
};
